export default "__VITE_ASSET__BBj$sEzK__"